import React, { useEffect, useState } from 'react'

export const AvatarProfesional = ({prof, clase}) => {

    const [imageUrl, setImageUrl] = useState({ url: '' });

    useEffect(() => {
        //console.log( 'profesional', profesional );
        const tieneImagenValida = prof.img && 
                                   prof.img.length > 0 && 
                                   prof.img[0] && 
                                   !prof.img[0].startsWith('data:image') &&
                                   prof.img[0] !== 'null' &&
                                   prof.img[0] !== '';
        
        if( tieneImagenValida ){
            getImagenPrincipal( `${prof.img[0]}` );
        } else {
            const baseUrl = process.env.REACT_APP_API_URL;
            const defaultUrl = `${baseUrl}/images/professionals/uploads/default-profesional.jpg`;
            setImageUrl({ url: defaultUrl });
        }
    }, [prof]);

    
    const getImagenPrincipal = async( imagen ) => {
        if (imagen && imagen.startsWith('data:image')) {
            const baseUrl = process.env.REACT_APP_API_URL;
            const defaultUrl = `${baseUrl}/images/professionals/uploads/default-profesional.jpg`;
            setImageUrl({ url: defaultUrl });
            return;
        }
        
        setImageUrl( { url: imagen } );
    }

    return (
        <div 
            key={ prof._id } 
            className={`${clase} ${imageUrl.url === '/assets/img/default-profesional.jpg' ? 'avatar--default' : ''}`}
            title={ prof.nombre }
            style={{ 
                backgroundImage: `${imageUrl.url ? 'url('+ imageUrl.url +'?'+ imageUrl.url +')' : 'none'}`,
                borderColor: `${ prof.color }`
            }}
        >
        </div>
    )
}
